module.exports = __webpack_public_path__ + "static/img/hair_08.76b2deb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_08.png
// module id = RKKV
// module chunks = 0